function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("stimulus")) : "function" == typeof define && define.amd ? define(["stimulus"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.stimulusReveal = e(require("stimulus")) : t.stimulusReveal = e(t.stimulus);
}(window, function (t) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 8);
  }([function (t, e, n) {
    var r = n(9),
        i = n(10),
        o = n(11),
        a = n(12);

    t.exports = function (t) {
      return r(t) || i(t) || o(t) || a();
    };
  }, function (t, e) {
    function n(e) {
      return t.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e) {
    t.exports = function (t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e) {
    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    t.exports = function (t, e, r) {
      return e && n(t.prototype, e), r && n(t, r), t;
    };
  }, function (t, e, n) {
    var r = n(13);

    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && r(t, e);
    };
  }, function (t, e, n) {
    var r = n(14),
        i = n(15);

    t.exports = function (t, e) {
      return !e || "object" !== r(e) && "function" != typeof e ? i(t) : e;
    };
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return g;
    }), n.d(e, "RevealController", function () {
      return g;
    });
    var r = n(0),
        i = n.n(r),
        o = n(3),
        a = n.n(o),
        s = n(4),
        u = n.n(s),
        c = n(5),
        l = n.n(c),
        f = n(6),
        p = n.n(f),
        y = n(1),
        d = n.n(y),
        h = n(7);

    function v(t, e) {
      var _n;

      if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
        if (Array.isArray(t) || (_n = function (t, e) {
          if (!t) return;
          if ("string" == typeof t) return m(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          "Object" === n && t.constructor && (n = t.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(t);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return m(t, e);
        }(t)) || e && t && "number" == typeof t.length) {
          _n && (t = _n);

          var r = 0,
              i = function i() {};

          return {
            s: i,
            n: function n() {
              return r >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[r++]
              };
            },
            e: function e(t) {
              throw t;
            },
            f: i
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var o,
          a = !0,
          s = !1;
      return {
        s: function s() {
          _n = t[Symbol.iterator]();
        },
        n: function n() {
          var t = _n.next();

          return a = t.done, t;
        },
        e: function e(t) {
          s = !0, o = t;
        },
        f: function f() {
          try {
            a || null == _n["return"] || _n["return"]();
          } finally {
            if (s) throw o;
          }
        }
      };
    }

    function m(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function b(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = d()(t);

        if (e) {
          var i = d()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return p()(this, n);
      };
    }

    var g = function (t) {
      l()(n, t);
      var e = b(n);

      function n() {
        return a()(this, n), e.apply(this, arguments);
      }

      return u()(n, [{
        key: "connect",
        value: function value() {
          this.data.set("open", this.isOpen), this._initCloseKeypressListener(), this._initToggleKeypressListener();
        }
      }, {
        key: "show",
        value: function value(t) {
          this.isOpen || this.isTransitioning || this._init(t, !0);
        }
      }, {
        key: "hide",
        value: function value(t) {
          this.isOpen && !this.isTransitioning && this._init(t, !1);
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this.isTransitioning || this._init(t, !this.isOpen);
        }
      }, {
        key: "_init",
        value: function value(t, e) {
          null == t || t.preventDefault();
          var n,
              r = this.data.has("targets") ? this.data.get("targets") : "[data-reveal]",
              i = v(this.element.querySelectorAll(r));

          try {
            for (i.s(); !(n = i.n()).done;) {
              var o = n.value;

              this._doInitTransition(o, e);
            }
          } catch (t) {
            i.e(t);
          } finally {
            i.f();
          }

          this._initAwayListener();
        }
      }, {
        key: "_initCloseKeypressListener",
        value: function value() {
          var t = this;
          this.data.has("close-keypress") && document.addEventListener("keydown", function (e) {
            t.isOpen && t.data.get("close-keypress").split(",").includes(e.key.toLowerCase()) && (e.stopPropagation(), t.toggle(e));
          });
        }
      }, {
        key: "_initToggleKeypressListener",
        value: function value() {
          var t = this;
          this.data.has("keypress") && document.addEventListener("keydown", function (e) {
            t.data.get("keypress").split(",").includes(e.key.toLowerCase()) && (e.stopPropagation(), t.toggle(e));
          });
        }
      }, {
        key: "_initAwayListener",
        value: function value() {
          var t = this;
          this.isOpen && this.data.has("away") && (this.awayHandler = function (e) {
            t.isOpen && !t.element.contains(e.target) && (t.toggle(e), document.removeEventListener("click", t.awayHandler));
          }, document.addEventListener("click", this.awayHandler));
        }
      }, {
        key: "_doInitTransition",
        value: function value(t, e) {
          var n = this;
          t.dispatchEvent(new Event("reveal:".concat(e ? "show" : "hide"), {
            bubbles: !0,
            cancelable: !1
          })), "transition" in t.dataset ? (this.transitionEndHandler = function () {
            n._didEndTransition(t, e);
          }, requestAnimationFrame(function () {
            n._transitionSetup(t, e), t.addEventListener("transitionend", n.transitionEndHandler), requestAnimationFrame(function () {
              n._doStartTransition(t, e);
            });
          })) : (e && (t.hidden = !t.hidden), this._doCompleteTransition(t, e));
        }
      }, {
        key: "_doStartTransition",
        value: function value(t, e) {
          if (this.data.set("transitioning", "true"), "true" === t.dataset.useTransitionClasses) {
            var n,
                r,
                o = this._transitionClasses(t, this.transitionType);

            (n = t.classList).add.apply(n, i()(o.end.split(" "))), (r = t.classList).remove.apply(r, i()(o.start.split(" ")));
          } else {
            var a = this._transitionDefaults(e);

            t.style.transformOrigin = a.origin, t.style.transitionProperty = "opacity transform", t.style.transitionDuration = "".concat(a.duration / 1e3, "s"), t.style.transitionTimingFunction = "cubic-bezier(0.4, 0.0, 0.2, 1)", t.style.opacity = a.to.opacity, t.style.transform = "scale(".concat(a.to.scale / 100, ")");
          }
        }
      }, {
        key: "_didEndTransition",
        value: function value(t, e) {
          if (t.removeEventListener("transitionend", this.transitionEndHandler), "true" === t.dataset.useTransitionClasses) {
            var n,
                r = this._transitionClasses(t, this.transitionType);

            (n = t.classList).remove.apply(n, i()(r.before.split(" ")));
          } else t.style.opacity = t.dataset.opacityCache, t.style.transform = t.dataset.transformCache, t.style.transformOrigin = t.dataset.transformOriginCache;

          this._doCompleteTransition(t, e);
        }
      }, {
        key: "_doCompleteTransition",
        value: function value(t, e) {
          this.data.set("transitioning", "false"), e || (t.hidden = !t.hidden), this.data.set("open", e), t.dispatchEvent(new Event("reveal:".concat(e ? "shown" : "hidden"), {
            bubbles: !0,
            cancelable: !1
          })), t.dispatchEvent(new Event("reveal:complete", {
            bubbles: !0,
            cancelable: !1
          }));
        }
      }, {
        key: "_transitionSetup",
        value: function value(t, e) {
          if (this.transitionType = e ? "transitionEnter" : "transitionLeave", this.transitionType in t.dataset) {
            var n, r;
            t.dataset.useTransitionClasses = !0;

            var o = this._transitionClasses(t, this.transitionType);

            (n = t.classList).add.apply(n, i()(o.before.split(" "))), (r = t.classList).add.apply(r, i()(o.start.split(" ")));
          } else {
            t.dataset.useTransitionClasses = !1;

            var a = this._transitionDefaults(e);

            t.dataset.opacityCache = t.style.opacity, t.dataset.transformCache = t.style.transform, t.dataset.transformOriginCache = t.style.transformOrigin, t.style.opacity = a.from.opacity, t.style.transform = "scale(".concat(a.from.scale / 100, ")");
          }

          e && (t.hidden = !t.hidden);
        }
      }, {
        key: "_transitionDefaults",
        value: function value(t) {
          return {
            duration: t ? 200 : 150,
            origin: "center",
            from: {
              opacity: t ? 0 : 1,
              scale: t ? 95 : 100
            },
            to: {
              opacity: t ? 1 : 0,
              scale: t ? 100 : 95
            }
          };
        }
      }, {
        key: "_transitionClasses",
        value: function value(t, e) {
          return {
            before: t.dataset[e],
            start: t.dataset["".concat(e, "Start")],
            end: t.dataset["".concat(e, "End")]
          };
        }
      }, {
        key: "isOpen",
        get: function get() {
          return "true" === this.data.get("open");
        }
      }, {
        key: "isTransitioning",
        get: function get() {
          return "true" === this.data.get("transitioning");
        }
      }]), n;
    }(h.Controller);
  }, function (t, e, n) {
    var r = n(2);

    t.exports = function (t) {
      if (Array.isArray(t)) return r(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    };
  }, function (t, e, n) {
    var r = n(2);

    t.exports = function (t, e) {
      if (t) {
        if ("string" == typeof t) return r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0;
      }
    };
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (t, e) {
    function n(e, r) {
      return t.exports = n = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, n(e, r);
    }

    t.exports = n;
  }, function (t, e) {
    function n(e) {
      return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? t.exports = n = function n(t) {
        return _typeof(t);
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }]);
});